import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const drawerWidth = 240;

const Layout = ({ theme }) => {
    const [headerShow, setHeaderShow] = useState(true);

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
            {/* Header */}
            <Header
                headerShow={headerShow}
                setHeaderShow={setHeaderShow}
            />

            {/* Main */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    pt: {
                        xs: '140px',
                        sm: '160px',
                        md: '110px',
                    },
                    px: {
                        xs: 1.5,
                        sm: 4,
                        md: 5,
                    },
                    pb: 3,
                }}
            >
                <Outlet />
            </Box>
            <Box
                component="footer"
                sx={{
                    px: {
                        xs: 1.5,
                        sm: 4,
                        md: 5,
                    },
                    py: 3,
                }}>
                <Footer />
            </Box>
        </Box>
    );
};

export default Layout;
